import React, { useState } from 'react';

const LoginPage = ({ login, setCurrentPage }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }
    
    const result = login(email, password);
    if (!result.success) {
      setError(result.error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <p>Sustainable Second-Hand Marketplace</p>
      </div>
      
      <div className="form">
        <h2>Login to Your Account</h2>
        {error && <div className="error">{error}</div>}
        
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        
        <button onClick={handleLogin}>
          Login
        </button>
        
        <button onClick={() => setCurrentPage('register')}>
          Don't have an account? Sign Up
        </button>
        
        <div style={{marginTop: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '4px'}}>
          <strong>Demo Account:</strong><br />
          Email: user@example.com<br />
          Password: password123
        </div>
      </div>
    </div>
  );
};

export default LoginPage;